/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_No_DomainsInputs */

const en_domain_manager_no_domains = /** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No custom domains connected`)
};

const es_domain_manager_no_domains = /** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay dominios personalizados conectados`)
};

const fr_domain_manager_no_domains = /** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun domaine personnalisé connecté`)
};

const de_domain_manager_no_domains = /** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine benutzerdefinierten Domains verbunden`)
};

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const ja_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const zh_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const ar_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const id_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const it_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const ru_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const pt_domain_manager_no_domains = en_domain_manager_no_domains;

/** @type {(inputs: Domain_Manager_No_DomainsInputs) => LocalizedString} */
const ko_domain_manager_no_domains = en_domain_manager_no_domains;

/**
* | output |
* | --- |
* | "No custom domains connected" |
*
* @param {Domain_Manager_No_DomainsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_no_domains = /** @type {((inputs?: Domain_Manager_No_DomainsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_No_DomainsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_no_domains(inputs)
	if (locale === "es") return es_domain_manager_no_domains(inputs)
	if (locale === "fr") return fr_domain_manager_no_domains(inputs)
	if (locale === "de") return de_domain_manager_no_domains(inputs)
	if (locale === "ja") return ja_domain_manager_no_domains(inputs)
	if (locale === "zh") return zh_domain_manager_no_domains(inputs)
	if (locale === "ar") return ar_domain_manager_no_domains(inputs)
	if (locale === "id") return id_domain_manager_no_domains(inputs)
	if (locale === "it") return it_domain_manager_no_domains(inputs)
	if (locale === "ru") return ru_domain_manager_no_domains(inputs)
	if (locale === "pt") return pt_domain_manager_no_domains(inputs)
	return ko_domain_manager_no_domains(inputs)
});